<template>
  <v-container fluid grid-list-xl pt-0>
    <v-card>
      <vue-perfect-scrollbar>
      <v-card-text style="padding-top: 0px">
      <v-card  lg12 style="margin-top: 10px; margin-bottom: 15px">
          <v-card-text class="pt-0">
            <v-layout row wrap style="margin-top: 10px;">
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-select
                  label="Sucursal"
                  v-model="buscar.sucursal"
                  :items="listSucursal"
                  class="form-control admin-input"
                  item-text="nombre"
                  item-value="nombre"
                  required
                  :clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-select
                  label="Estado"
                  v-model="buscar.estado"
                  :items="listEstado"
                  class="form-control admin-input"
                  required
                      :clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-select
                  label="Transacción"
                  v-model="buscar.transaccion"
                  :items="listEstadoTRM"
                  class="form-control admin-input"
                  required
                      :clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-select
                  label="Estado pago"
                  v-model="buscar.estadoPago"
                  :items="listEstadoPago"
                  class="form-control admin-input"
                  required
                      :clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-text-field
                  class="form-control admin-input"
                  label="Número de Oportunidad"
                  v-model="buscar.oportunidad"
                      :clearable="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-text-field
                  class="form-control admin-input"
                  label="Identificación Cliente"
                  v-model="buscar.identificacion"
                      :clearable="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4 lg4 xl2>
                  <v-text-field
                    label="Fecha de Inicio"
                    :clearable="true"
                    v-model="buscar.fechaInicio"
                    type="date"
                  ></v-text-field>
                
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-text-field
                    label="Fecha fin"
                    :clearable="true"
                    v-model="buscar.fechaFin"
                    type="date"
                  ></v-text-field>
                
              </v-flex>

              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-select
                  label="Canal"
                  v-model="buscar.CanalVenta"
                  :items="listCanales"
                  class="form-control admin-input"
                  item-text="description"
                  item-value="code"
                  required
                      :clearable="true"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl2>
                <v-text-field
                  class="form-control admin-input"
                  label="Buscador por Coincidencia"
                  v-model="buscar.buscar"
                      :clearable="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4 lg4 xl4>
                <div style="float: right">
                  <v-btn
                    color="#00aeef"
                    small
                    @click="filtrar"
                    title="Buscar"
                    style="color: #fff"
                  >
                    Buscar
                  </v-btn>
                  <v-btn
                    color="#00aeef"
                    small
                    @click="descargar"
                    title="Descargar"
                    style="color: #fff"
                  >
                    Exportar
                  </v-btn>
                  <v-btn
                    color="default"
                    small
                    @click="limpiar"
                    title="Limpiar"
                  >
                    Limpiar
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>

          <v-layout row wrap style="margin-top: 10px;">
          <v-flex lg12>
          <v-card-text class="row pt-1">
            <v-flex class="row pt-4">
              <v-data-table
                dense
                :headers="headers"
                :items="list"
                item-key="name"
                class="v-table-list theme--light table-default"
              >
                <template slot="headers" scope="props">
                  <tr>
                    <th
                      style="color: #005cae"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column',
                        header.align == 'left'
                          ? 'text-xs-left'
                          : header.align == 'left'
                          ? 'text-xs-left'
                          : 'text-xs-ef',
                        header.value === pagination.sortBy ? 'active' : '',
                      ]"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" scope="props">
                  <tr v-bind:class="{ table__selected: props.selected }">
                    <td class="text-xs-left cut-text">
                      {{ props.item.identificacion }}
                    </td>
                    <td class="text-xs-left cut-text" style="width: 150px">
                      {{ props.item.cliente }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.email }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.telefono }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.tipoPersona }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.sucursal }}
                    </td>
                    <td class="text-xs-left cut-text">{{ props.item.aps }}</td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.valorCuota }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.marca }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.placa }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.sumaAsegurada }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.noOportunidad }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.fechaCotizacion }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.fechaPago }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.estado }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.estadoPago }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.estadoTRM }}
                    </td>
                    <td class="text-xs-left cut-text">{{ props.item.emi }}</td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.poliza }}
                    </td>
                    <td class="text-xs-left cut-text">
                      {{ props.item.canalVenta }}
                    </td>
                    <td class="text-xs-left">
                      <table style="text-xs-center">
                        <tr>
                          <td style="padding: 0 !important; margin: 0">
                            <v-btn
                              small
                              text
                              icon
                              fab
                              title="Reenviar Url"
                              @click="enviar(props.item.id)"
                            >
                              <v-icon color="blue" dark medium>email</v-icon>
                            </v-btn>
                          </td>
                          <td style="padding: 0 !important; margin: 0">
                            <v-btn
                              small
                              text
                              icon
                              fab
                              title="Dar de baja"
                              @click="cancelar(props.item.id)"
                            >
                              <v-icon color="blue" dark medium>delete</v-icon>
                            </v-btn>
                          </td>
                          
                          <td
                            class="text-xs-center"
                            style="padding: 0 !important; margin: 0"
                          >
                            <AccionDetail
                              :id="props.item.id"
                              :accion="props.item.acciones"
                              @filtrar="filtrar"
                              
                            />
                            
                          </td>

                          <td
                            class="text-xs-center"
                            style="padding: 0 !important; margin: 0"
                          >
                            <v-btn
                              small
                              text
                              icon
                              fab
                              title="Ver Cotización"
                              @click="dowloadPdf(props.item.id)"
                            >
                              <v-icon color="blue" dark medium
                                >fas fa-eye</v-icon
                              >
                            </v-btn>
                          </td>
                          
                        </tr>
                      </table>
                    </td>
                    
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
          </v-flex>
          </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
      </vue-perfect-scrollbar>  
    </v-card>
  </v-container>
    
</template>
<script>

import service from "@/services/EcommerceServices";
import { mapGetters, mapActions } from "vuex";
import { saveExcel } from '@progress/kendo-vue-excel-export';
import AccionDetail from "./AccionDetail";

export default {
  data() {
    return {
      load:false,
      buscar:{
        sucursal: null,
        estado: null,
        transaccion:null ,
        user_id:0
      },
      listSucursal:[],
      listEstado: [
        "Cotización",
        "Falta Pago",
        "Falta FVC",
        "Falta Inspección",
        "Inspección Rechazada",
        "Pago No Aprobado",
        "Emitido Póliza",
        "Inspección Realizada"
      ],
      listEstadoPago: ["Aprobado", "Rechazada"],
      listEstadoTRM: ["Pendiente", "Aplicado"],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        rowsPerPageItems: [10],
      },
      list:[],
      listCanales:[],
      headers: [
        {
          align: "center",
          sortable: false,
          text: "Identificación",
          value: "identification",
        },
        {
          align: "center",
          sortable: false,
          text: "Cliente",
          value: "name",
          width: "100px"
        },
        {
          align: "center",
          sortable: false,
          text: "Email",
          value: "email",
        },
        {
          align: "center",
          sortable: false,
          text: "Teléfono",
          value: "phone",
        },
        {
          align: "center",
          sortable: false,
          text: "Tipo de persona",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Sucursal",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "APS",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Valor Cuota",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Marca",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Placa",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Suma Asegurada",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Número de Oportunidad",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Fecha de Cotización",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Fecha de Pago",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Estado",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Estado Pago",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Estado TRN",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "No. EMI",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "No. Póliza",
          value: "salary",
        },
        {
          align: "center",
          sortable: false,
          text: "Canal",
        },{
          align: "center",
          sortable: false,
          text: "Acciones",
        },
      ],
    };
  },
  components: {
    AccionDetail,
  },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  methods: {
    getSucursal(){
      const suc = service.getSucursal()
      suc.then(res => {
      this.listSucursal = res.data.data;
      })      
    },
    filtrar() {
        this.load = true;
        this.buscar.user_id = this.userProfile.user_id;
        console.log('buscar', this.buscar);
        const list = service.getList(this.buscar);
        list.then(data=>{
          this.list = data.data
        })
    },
    getCanal(){
      const canal = service.getCanales(this.userProfile.user_id)
       canal.then(res => {
         console.log('canales',res.data.data);
       })
    },
    
    enviar(id) {
      this.load = true;
      const varService = service.actionEnviar(id);
      varService.then(() => {
         this.errors.push({
            key: true,
            value: "Se ha enviado un correo",
          });
          this.load = false;
      }).catch((err) => {
          this.load = false;
      });
    },
    cancelar(id){
     this.load = true;
     service.actionCancelar(id).then(() => {
        this.getList(this.buscar)
          .then((resul) => {
            this.setList(resul.data);
            this.getLoad(false);
            this.load = false;
          })
          .catch(() => {
            this.getLoad(false);
            this.load = false;
          });
      });
    },
    dowloadPdf(id){
      const pdf = service.dowloadPdf(id);
      window.open(pdf, '_blank');
    },
    descargar() {
      saveExcel({
          data: this.list,
          fileName: "Cotizaciones",
          columns: [
            { field: 'identificacion', title: "Identificación" },
            { field: 'cliente', title: "Cliente" },
            { field: 'email', title: "Email" },
            { field: 'phone', title: "Teléfono" },
            { field: 'sucursal', title: "Sucursal" },
            { field: 'aps', title: "APS" },
            { field: 'valorCuota', title: "Valor Cuota" },
            { field: 'marca', title: "Marca" },
            { field: 'placa', title: "Placa" },
            { field: 'sumaAsegurada', title: "Suma Asegurada" },
            { field: 'noOportunidad', title: "Número de Oportunidad" },
            { field: 'fechaCotizacion', title: "Fecha de Cotización" },
            { field: 'rechaPago', title: "Fecha de Pago" },
            { field: 'estado', title: "Estado" },
            { field: 'estadoPago', title: "Estado Pago" },
            { field: 'estadoTRN', title: "Estado TRN" },
            { field: 'poliza', title: "No. Póliza" },
            { field: 'canalVenta', title: "Canal" },
        ]
      });
    },
    limpiar() {
      this.buscar.sucursal = undefined;
      this.buscar.estado = undefined;
      this.buscar.transaccion = undefined;
      this.buscar.estadoPago = undefined;
      this.buscar.oportunidad = undefined;
      this.buscar.identificacion = undefined;
      this.buscar.fechaInicio = undefined;
      this.buscar.fechaFin = undefined;
      this.buscar.buscar = undefined;
      this.buscar.CanalVenta = undefined;
    },
  },
  mounted() {
    this.getSucursal();
    this.getCanal();
  },
  
};
</script>
<style scope>
.table-default td {
    padding: 0px 25px !important;
        padding-right: 0px 25px;
    padding-right: 5px !important;
}
.container-body {
  width: 100%;
}
.admin-input {
  padding-left: 25px;
}
.container.grid-list-xl .layout .flex {
    padding: 8px;
}
</style>